import { handleComponentError } from "../decorators/handleComponentError"
import { AlignmentType } from "../types/alignment.type"
import { ForgotPasswordComponentInterface } from "../types/forgotPassword.interface"
import { ForgotPasswordPositionEnum } from "../types/forgotPasswordPosition.enum"
import { ForgotPasswordPositionType } from "../types/forgotPasswordPosition.type"
import { Link } from "./link"

export class ForgotPassword extends Link {
    override props!: ForgotPasswordComponentInterface
    private buttonElement = document.getElementById("submit-button")

    constructor(props: ForgotPasswordComponentInterface) {
        super(props)
    }

    private setPosition(position?: ForgotPasswordPositionType) {
        if (position === ForgotPasswordPositionEnum.BELOW_BUTTON) {
            this.buttonElement?.insertAdjacentElement(
                "afterend",
                this.element?.parentElement as HTMLElement
            )
            this.buttonElement?.style.setProperty("margin-top", ".5rem")
        }
    }

    private setAlignment(alignment?: AlignmentType) {
        if (alignment) {
            const alignPosition = {
                LEFT: "flex-start",
                CENTER: "center",
                RIGHT: "flex-end"
            }[alignment]

            this.element?.parentElement?.style.setProperty(
                "justify-content",
                alignPosition ?? "flex-end"
            )
        }
    }

    @handleComponentError("ForgotPassword")
    render(): void {
        this.setPosition(this.props.position)
        this.setAlignment(this.props.alignment)

        super.render()
    }
}
